import { RdProject } from '@neo.tax/rd/hooks';

import { RdProjectInfoForm } from './rd-project-detail-form.types';

export const makeDefaultFormValues = (rdProject: RdProject): RdProjectInfoForm => ({
  name: rdProject.name,
  description: rdProject.description ?? '',
  productId: rdProject.product?.id ?? null,
  projectOwnerId: rdProject.projectOwner?.id ?? null,
});
